import Base from '../../../src/js/classes/Base'
import gsap from 'gsap'
import imagesLoaded from 'imagesloaded'

export default class PageTransition extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				wrapper: document.querySelector('[data-transition="wrapper"]'),
				itemsContainer: '.e-PageTransition__images',
				items: '.e-PageTransition__images__image',
				img: 'img',
			},
			classes: {
				initialised: 'initialised',
				preloaded: 'preloaded',
			},
		})
	}

	init() {}

	update() {}

	once() {
		// imagesLoaded(this.elements.img, () => {
		// 	gsap.to(this.element, {
		// 		yPercent: -100,
		// 		// opacity: 0,
		// 		delay: 2,
		// 		duration: 0.7,
		// 		ease: 'in',
		// 		onComplete: () => {
		// 			this.element.classList.add(this.classes.preloaded)
		// 		},
		// 	})
		// })
	}

	leave(resolve) {
		gsap.to(this.elements.wrapper, {
			opacity: 0,
			duration: 0.5,
			ease: 'power2.in',
			onComplete: () => resolve(),
		})
	}

	after() {
		window.scrollTo(0, 0)
		gsap.set(this.elements.wrapper, {
			opacity: 0,
		})
		gsap.to(this.elements.wrapper, {
			opacity: 1,
			duration: 0.5,
			ease: 'power2.out',
			onComplete: () => {
				window.emitter.emit('pageReady')
			},
		})
	}

	unmount() {}
}
